import React from "react";
import "./component-css/LearningMaterials.css";

const UrbanResilience = () => {
        const materials = [
            {
                title: "Understanding Urban Resilience",
                type: "pdf",
                link: "/materials/urban-resilience/IUAV_English.pdf",
                description:
                    "A brief look at how cities can prepare for and adapt to climate and social challenges."
            },
            {
                title: "Surviving Active Attacks: A Webinar on Resilience",
                type: "youtube",
                link: "https://youtu.be/FDFXfd5DUAs",
                description:
                    "An overview of strategies and practices for improving preparedness and resilience in the face of active threat situations."
            },
            {
                title: "Spatial Planning for Climate Change Resilience",
                type: "youtube",
                link: "https://youtu.be/zV2TW88CJ_k",
                description:
                    "An overview of spatial planning approaches that support climate change resilience and sustainable urban development."
            },
            {
                title: "Planning Sustainable Food Systems",
                type: "youtube",
                link: "https://youtu.be/hGKWXPuML80",
                description:
                    "An overview of planning approaches for developing sustainable and resilient food systems."
            },
            {
                title: "Digital Cities: Spatial Data Analytics for Urban Planning and Governance",
                type: "youtube",
                link: "https://youtu.be/GJK2AooIHxo",
                description:
                    "An overview of how spatial data analytics can support smarter urban planning and city governance."
            },
            {
                title: "Circular Economy & Urban Metabolism: A Framework for Transformative and Sustainable Cities",
                type: "youtube",
                link: "https://youtu.be/ajPTErDY3L8",
                description:
                    "An overview of circular economy and urban metabolism concepts for supporting more sustainable and resource-efficient cities."
            },
            {
                title: "Community Resilience to Disasters",
                type: "youtube",
                link: "https://youtu.be/8gHSQpHOpBs",
                description:
                    "An introduction to the concept of community resilience and how communities can better prepare for and respond to disasters."
            },
            {
                title: "Recast EU Urban Wastewater Treatment Directive: An Albanian Perspective",
                type: "youtube",
                link: "https://youtu.be/W4Z9GMVl-1g",
                description:
                    "Overview of the EU wastewater directive and its implications for urban water management in Albania."
            }
        ];
    return (
        <div className="content-page lm-page">
            <header className="lm-header">
                <h1 className="lm-title">Urban Resilience Learning Materials</h1>
                <p className="lm-subtitle">
                    Guides and videos on planning adaptive cities that withstand
                    climate, social, and environmental challenges.
                </p>
            </header>

            <div className="lm-list">
                {materials.map((m, index) => (
                    <div key={index} className="lm-card">
                        <h3 className="lm-card-title">{m.title}</h3>

                        <p className="lm-card-desc">{m.description}</p>

                        <a
                            href={m.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="lm-card-link"
                        >
                            {m.type === "pdf" ? "📄 Open PDF" : "▶ Watch Video"}
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default UrbanResilience;
